import { HttpRequest } from "../utils"

const httpRequest = new HttpRequest()

export interface IPullSheetLineShortage {
  pullSheetLineId: string
  pullSheetId: string
  businessId: string
  shortQuantity: string                // DECIMAL → string from sequelize
  reasonCode: string
  reasonText: string | null
  photoUrls: string[]
  reportedByUserId: string
  reportedAt: string
  createdAt?: string
  updatedAt?: string
}

export interface IShortageDecision {
  decision: "AUTO_SPLIT" | "COORDINATOR_REVIEW" | "MANAGER_ESCALATION" | "NONE"
  shortagePercent: number
  totalLines: number
  shortLines: number
  /** Σ loaded units and Σ short units: the percent is quantity-weighted (contract §2, O137). */
  totalQuantity: number
  shortQuantity: number
  options: string[]
}

/** BE constants/SHORTAGE_REASON_CODE.ts: the only six values the backend accepts. */
export const SHORTAGE_REASON_CODES = ["DAMAGED", "EXPIRED", "NOT_FOUND", "MISCOUNT", "QUALITY_REJECT", "OTHER"] as const

export interface IReportShortageInput {
  shortQuantity: number
  reasonCode: string
  reasonText?: string | null
  photoUrls?: string[]
  /** false = the backend answers 409 error.shortage.already_reported when the line has one (O144). */
  replace?: boolean
}

export const reportShortage = async (
  pullSheetId: string,
  lineId: string,
  body: IReportShortageInput,
): Promise<IPullSheetLineShortage> => {
  return httpRequest.post(`/ord/pull_sheet/${pullSheetId}/lines/${lineId}/shortage`, body as any)
}

export const listShortages = async (pullSheetId: string): Promise<IPullSheetLineShortage[]> => {
  return httpRequest.get(`/ord/pull_sheet/${pullSheetId}/shortages`)
}

export const getDecision = async (pullSheetId: string): Promise<IShortageDecision> => {
  return httpRequest.get(`/ord/pull_sheet/${pullSheetId}/shortage_decision`)
}
